import { HoverCard as HoverCardBase, HoverCardContent, HoverCardTrigger } from '@radix-ui/react-hover-card'
import { ReactNode } from 'react'

interface HoverCardProps {
  children: ReactNode
  trigger: ReactNode
  openDelay?: number
  closeDelay?: number
  align?: "center" | "end" | "start"
  className?: string
}

export default function HoverCard({
  children,
  trigger,
  openDelay = 10,
  closeDelay = 100,
  align = 'center',
  className
}: HoverCardProps) {
  return (
    <HoverCardBase openDelay={openDelay} closeDelay={closeDelay}>
      <HoverCardTrigger>
        {trigger}
      </HoverCardTrigger>
      <HoverCardContent align={align} className={className}>
        {children}
      </HoverCardContent>
    </HoverCardBase>
  )
}
